// extracted by mini-css-extract-plugin
export default {"add":"control_add__yMbn3","tooltip":"control_tooltip__Alp+m"};